import HeroSection from '../../../../components/conduct-risk/HeroSection';
import { routesMap } from '../../../../routes/AppRoutes';
import { Reports } from '../../../../api/apiTypes';

interface DataFromParent {
  report: Reports | undefined;
  title: string | undefined;
  reportId?: string;
}

const BannerIndiceDiSolidita = ({ report, reportId }: DataFromParent) => {
  return (
    <HeroSection
      title="Indice di Solidità"
      description="Consulta l'indice di solidità finanziaria degli intermediari."
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: routesMap.REPORT_PAGE, title: 'Report' },
        { url: routesMap.VISUALIZZA_REPORT(report?.name ?? ''), title: report?.name ?? '', state: { id: reportId } },
        { url: '#', title: 'Indice di Solidità' },
      ]}
    />
  );
};

export default BannerIndiceDiSolidita;
